<a
  class="p-button p-button-sm dialog-link {{ styleClass }}"
  [class.p-disabled]="disabled"
  [attr.href]="disabled ? null : href"
  [attr.target]="target"
  [pTooltip]="tooltip"
  [tooltipPosition]="tooltipPosition"
>
  @if (iconLeft) {
  <i [class]="iconLeft"></i>
  } @if (label) {
  <span>{{ label }}</span>
  } @if (iconRight) {
  <i [class]="iconRight"></i>
  }
</a>
